import React from 'react';
import { Tooltip } from 'antd';
import { MobileOutlined, TabletOutlined, DesktopOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import globalMessages from 'translations/messages';

const deviceTypeIcons = [{
  label: 'mobile',
  icon: MobileOutlined,
}, {
  label: 'tablet',
  icon: TabletOutlined,
}, {
  label: 'desktop',
  icon: DesktopOutlined,
},
];

const DeviceTypeIcons = ({ deviceTypes }) => deviceTypeIcons.filter(d => !deviceTypes?.length || deviceTypes.includes(d.label.toUpperCase())).map(({ label, icon: Icon }) => <Tooltip key={label} title={<FormattedMessage {...globalMessages[label]} />}><Icon style={{ marginRight: '.5em' }} rotate={label === 'tablet' ? 90 : 0} /></Tooltip>);

export default DeviceTypeIcons;
